<script>
import { Line } from "vue-chartjs";
import moment from "moment-jalaali";
import numeral from "numeral";

export default {
  name: "ComareChart",
  props: {
    sourceId: "",
    flightList: Array,
    hotelList: Array,
    tourismList: Array,
    selectedDateType: Number,
    selectedSearchType: Number,
  },
  extends: Line,
  data() {
    return {
      gradient: null,
      gradient2: null,
      gradient3: null,

      currentPersianDate: "",
      currentDate: "",
      label: "",
      labels: [],
      flightDataSet: [],
      hotelDataSet: [],
      tourismDataSet: [],
    };
  },
  mounted() {
    this.getCurrentDate();
    if (this.sourceId != "") {
      if (this.selectedDateType == 1) {
        this.setFligthDailyData(this.flightList);
        this.setHotelDailyData(this.hotelList);
        this.setTourismDailyData(this.tourismList);
      } else if (this.selectedDateType == 2) {
        this.setMonthyData();
      } else if (this.selectedDateType == 3) {
        this.setYearlyData();
      }
    }
  },
  methods: {
    loadChart() {
      this.gradient = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 450);
      this.gradient2 = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 450);

      this.gradient3 = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 450);

      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: "گردشگری",
              borderColor: "#F39C12",
              pointBackgroundColor: "#F39C12",
              pointBorderColor: "white",
              borderWidth: 3,
              backgroundColor: this.gradient,
              data: this.tourismDataSet,
            },

            {
              label: "پرواز",
              borderColor: "#00C0EF",
              pointBackgroundColor: "#00C0EF",
              borderWidth: 3,
              pointBorderColor: "white",
              backgroundColor: this.gradient,
              data: this.flightDataSet,
            },
            {
              label: "هتل",
              borderColor: "#00A65A",
              pointBackgroundColor: "#00A65A",
              pointBorderColor: "white",
              borderWidth: 3,
              backgroundColor: this.gradient,
              data: this.hotelDataSet,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
            onProgress: function (animation) {},
          },
          legend: {
            labels: {
              // boxWidth: 60,
              // boxHeight: 5,
              fontSize: 18,
            },
            position: "top",
          },

          scales: {
            yAxes: [
              {
                ticks: {
                  fontSize: 14,
                  beginAtZero: true,
                  callback: (value, index, values) => {
                    return `${this.converCurrencyFormat(value)}`;
                  },
                },
              },
            ],
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItems, data) => {
                return ` ${this.converCurrencyFormat(tooltipItems.value)}`;
              },
            },
          },
        }
      );
    },
    converCurrencyFormat(num) {
      return numeral(num).format("0,0");
    },
    getCurrentDate() {
      let currentFulldate = new Date();

      let currentdate =
        currentFulldate.getFullYear() +
        "/" +
        (currentFulldate.getMonth() + 1) +
        "/" +
        String(currentFulldate.getDate()).padStart(2, "0");

      let toPersianDate = moment(currentdate).format("jYYYY/jMM/jDD");

      // let fromPersianDate = toPersianDate.substring(8, 0) + "01";

      this.currentPersianDate = toPersianDate;
    },
    convertToMonthDay(date) {
      const pDate = moment(date, "jYYYY/jMM/jDD").format("jMM/jDD");
      return pDate;
    },
    convertToPersianDate(date) {
      if (date === "0001-01-01T00:00:00") return "";
      if (!moment(date).isValid()) return "";
      const pdate = moment(date).format("jYYYY/jMM/jDD");

      return pdate;
    },

    convertDate(date) {
      const mdate = moment(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD");
      return mdate;
    },
    addDays(startDate) {
      const date = moment(startDate, "jYYYY/jMM/jDD")
        .add(1, "days")
        .format("jYYYY/jMM/jDD");
      return date;
    },
    addMonths(startMonth) {
      const date = moment(startMonth, "jYYYY/jMM")
        .add(1, "jMonth")
        .format("jYYYY/jMM");

      return date;
    },
    setFligthDailyData(reportList) {
      let labesDate = "";
      this.labels = [];
      this.flightDataSet = [];

      let startDate = this.currentPersianDate.substring(8, 0) + "01";
      this.labels.push(this.convertToMonthDay(startDate));

      let currentMonth = parseInt(this.currentPersianDate.substring(7, 5));
      let toDate = "";
      if (currentMonth > 6 && currentMonth <= 11)
        toDate = this.currentPersianDate.substring(8, 0) + "30";
      else if (currentMonth === 12)
        toDate = this.currentPersianDate.substring(8, 0) + "29";
      else toDate = this.currentPersianDate.substring(8, 0) + "31";

      while (startDate != toDate) {
        if (
          reportList.find(
            (p) => this.convertToPersianDate(p.bookingDateTime) == startDate
          )
        ) {
          if (this.selectedSearchType == 1) {
            let totalPayed = reportList.find(
              (p) => this.convertToPersianDate(p.bookingDateTime) == startDate
            ).count;
            this.flightDataSet.push(totalPayed);
          } else {
            let totalPayed = reportList.find(
              (p) => this.convertToPersianDate(p.bookingDateTime) == startDate
            ).totalPayed;
            this.flightDataSet.push(totalPayed);
          }
        } else {
          this.flightDataSet.push(0);
        }

        startDate = this.addDays(startDate);
        this.labels.push(this.convertToMonthDay(startDate));
      }
    },
    setHotelDailyData(reportList) {
      this.hotelDataSet = [];

      let startDate = this.currentPersianDate.substring(8, 0) + "01";

      let currentMonth = parseInt(this.currentPersianDate.substring(7, 5));
      let toDate = "";
     if (currentMonth > 6 && currentMonth <= 11)
        toDate = this.currentPersianDate.substring(8, 0) + "30";
      else if (currentMonth === 12)
        toDate = this.currentPersianDate.substring(8, 0) + "29";
      else toDate = this.currentPersianDate.substring(8, 0) + "31";

      while (startDate != toDate) {
        if (
          reportList.find(
            (p) => this.convertToPersianDate(p.bookingDateTime) == startDate
          )
        ) {
          if (this.selectedSearchType == 1) {
            let totalPayed = reportList.find(
              (p) => this.convertToPersianDate(p.bookingDateTime) == startDate
            ).count;
            this.hotelDataSet.push(totalPayed);
          } else {
            let totalPayed = reportList.find(
              (p) => this.convertToPersianDate(p.bookingDateTime) == startDate
            ).totalPayed;
            this.hotelDataSet.push(totalPayed);
          }
        } else {
          this.hotelDataSet.push(0);
        }

        startDate = this.addDays(startDate);
      }
    },
    setTourismDailyData(reportList) {
      this.tourismDataSet = [];

      let sDate = this.currentPersianDate.substring(8, 0) + "01";

      let currentMonth = parseInt(this.currentPersianDate.substring(7, 5));
      let toDate = "";
    if (currentMonth > 6 && currentMonth <= 11)
        toDate = this.currentPersianDate.substring(8, 0) + "30";
      else if (currentMonth === 12)
        toDate = this.currentPersianDate.substring(8, 0) + "29";
      else toDate = this.currentPersianDate.substring(8, 0) + "31";

      while (sDate != toDate) {
        if (
          reportList.find(
            (p) => this.convertToPersianDate(p.bookingDateTime) == sDate
          )
        ) {
          if (this.selectedSearchType == 1) {
            let totalPayed = reportList.find(
              (p) => this.convertToPersianDate(p.bookingDateTime) == sDate
            ).count;
            this.tourismDataSet.push(totalPayed);
          } else {
            let totalPayed = reportList.find(
              (p) => this.convertToPersianDate(p.bookingDateTime) == sDate
            ).totalPayed;
            this.tourismDataSet.push(totalPayed);
          }
        } else {
          this.tourismDataSet.push(0);
        }

        sDate = this.addDays(sDate);
      }

      this.loadChart();
    },
    setMonthyData() {
      this.labels = [];
      this.flightDataSet = [];
      this.hotelDataSet = [];
      this.tourismDataSet = [];

      let startMonth = this.currentPersianDate.substring(5, 0) + "01";
      let toMonth = this.currentPersianDate.substring(5, 0) + "12";

      while (startMonth <= toMonth) {
        if (this.selectedSearchType == 1) {
          this.setMonths_count(startMonth);
        } else {
          this.setMonths_totalPay(startMonth);
        }
        startMonth = this.addMonths(startMonth);
      }

      this.loadChart();
    },
    setMonths_count(startMonth) {
      this.labels.push(startMonth);

      if (this.flightList.find((p) => p.bookingDateShamsi == startMonth)) {
        let counts = this.flightList.find(
          (p) => p.bookingDateShamsi == startMonth
        ).count;
        this.flightDataSet.push(counts);
      } else {
        this.flightDataSet.push(0);
      }

      if (this.hotelList.find((p) => p.bookingDateShamsi == startMonth)) {
        let counts = this.hotelList.find(
          (p) => p.bookingDateShamsi == startMonth
        ).count;

        this.hotelDataSet.push(counts);
      } else {
        this.hotelDataSet.push(0);
      }

      if (this.tourismList.find((p) => p.bookingDateShamsi == startMonth)) {
        let counts = this.tourismList.find(
          (p) => p.bookingDateShamsi == startMonth
        ).count;

        this.tourismDataSet.push(counts);
      } else {
        this.tourismDataSet.push(0);
      }
    },
    setMonths_totalPay(startMonth) {
      this.labels.push(startMonth);

      if (this.flightList.find((p) => p.bookingDateShamsi == startMonth)) {
        let totalPayeds = this.flightList.find(
          (p) => p.bookingDateShamsi == startMonth
        ).totalPayed;
        this.flightDataSet.push(totalPayeds);
      } else {
        this.flightDataSet.push(0);
      }

      if (this.hotelList.find((p) => p.bookingDateShamsi == startMonth)) {
        let totalPayeds = this.hotelList.find(
          (p) => p.bookingDateShamsi == startMonth
        ).totalPayed;

        this.hotelDataSet.push(totalPayeds);
      } else {
        this.hotelDataSet.push(0);
      }

      if (this.tourismList.find((p) => p.bookingDateShamsi == startMonth)) {
        let totalPayeds = this.tourismList.find(
          (p) => p.bookingDateShamsi == startMonth
        ).totalPayed;

        this.tourismDataSet.push(totalPayeds);
      } else {
        this.tourismDataSet.push(0);
      }
    },
    setYearlyData() {
      this.labels = [];
      this.flightDataSet = [];
      this.hotelDataSet = [];
      this.tourismDataSet = [];

      let minFlightYear = Math.min.apply(
        Math,
        this.flightList.map((p) => p.bookingDateShamsi)
      );
      let minHotelYear = Math.min.apply(
        Math,
        this.hotelList.map((p) => p.bookingDateShamsi)
      );
      let minTourismYear = Math.min.apply(
        Math,
        this.tourismList.map((p) => p.bookingDateShamsi)
      );

      let maxFlightYear = Math.max.apply(
        Math,
        this.flightList.map((p) => p.bookingDateShamsi)
      );
      let maxHotelYear = Math.max.apply(
        Math,
        this.hotelList.map((p) => p.bookingDateShamsi)
      );
      let maxTourismYear = Math.max.apply(
        Math,
        this.tourismList.map((p) => p.bookingDateShamsi)
      );

      let minYearArr = [minFlightYear, minHotelYear, minTourismYear];
      let maxYearArr = [maxFlightYear, maxHotelYear, maxTourismYear];

      let startYear = Math.min.apply(Math, minYearArr);
      let toYear = Math.max.apply(Math, maxYearArr);

      while (startYear <= toYear) {
        if (this.selectedSearchType == 1) {
          this.setYears_count(startYear);
        } else {
          this.setYears_totalPayed(startYear);
        }
        startYear++;
      }

      this.loadChart();
    },
    setYears_count(startYear) {
      this.labels.push(startYear);

      if (this.flightList.find((p) => p.bookingDateShamsi == startYear)) {
        let counts = this.flightList.find(
          (p) => p.bookingDateShamsi == startYear
        ).count;
        this.flightDataSet.push(counts);
      } else {
        this.flightDataSet.push(0);
      }

      if (this.hotelList.find((p) => p.bookingDateShamsi == startYear)) {
        let counts = this.hotelList.find(
          (p) => p.bookingDateShamsi == startYear
        ).count;

        this.hotelDataSet.push(counts);
      } else {
        this.hotelDataSet.push(0);
      }

      if (this.tourismList.find((p) => p.bookingDateShamsi == startYear)) {
        let counts = this.tourismList.find(
          (p) => p.bookingDateShamsi == startYear
        ).count;

        this.tourismDataSet.push(counts);
      } else {
        this.tourismDataSet.push(0);
      }
    },
    setYears_totalPayed(startYear) {
      this.labels.push(startYear);

      if (this.flightList.find((p) => p.bookingDateShamsi == startYear)) {
        let totalPayeds = this.flightList.find(
          (p) => p.bookingDateShamsi == startYear
        ).totalPayed;
        this.flightDataSet.push(totalPayeds);
      } else {
        this.flightDataSet.push(0);
      }

      if (this.hotelList.find((p) => p.bookingDateShamsi == startYear)) {
        let totalPayeds = this.hotelList.find(
          (p) => p.bookingDateShamsi == startYear
        ).totalPayed;

        this.hotelDataSet.push(totalPayeds);
      } else {
        this.hotelDataSet.push(0);
      }

      if (this.tourismList.find((p) => p.bookingDateShamsi == startYear)) {
        let totalPayeds = this.tourismList.find(
          (p) => p.bookingDateShamsi == startYear
        ).totalPayed;

        this.tourismDataSet.push(totalPayeds);
      } else {
        this.tourismDataSet.push(0);
      }
    },
  },

  watch: {
    flightList(val) {
      if (this.selectedDateType == 1) {
        this.setFligthDailyData(this.flightList);
        this.setHotelDailyData(this.hotelList);
        this.setTourismDailyData(this.tourismList);
      } else if (this.selectedDateType == 2) {
        this.setMonthyData();
      } else if (this.selectedDateType == 3) {
        this.setYearlyData();
      }
    },
    hotelList(val) {
      if (this.selectedDateType == 1) {
        this.setFligthDailyData(this.flightList);
        this.setHotelDailyData(this.hotelList);
        this.setTourismDailyData(this.tourismList);
      } else if (this.selectedDateType == 2) {
        this.setMonthyData();
      } else if (this.selectedDateType == 3) {
        this.setYearlyData();
      }
    },
    tourismList(val) {
      if (this.selectedDateType == 1) {
        this.setFligthDailyData(this.flightList);
        this.setHotelDailyData(this.hotelList);
        this.setTourismDailyData(this.tourismList);
      } else if (this.selectedDateType == 2) {
        this.setMonthyData();
      } else if (this.selectedDateType == 3) {
        this.setYearlyData();
      }
    },

    selectedSearchType(val) {
      if (this.selectedDateType == 1) {
        this.setFligthDailyData(this.flightList);
        this.setHotelDailyData(this.hotelList);
        this.setTourismDailyData(this.tourismList);
      } else if (this.selectedDateType == 2) {
        this.setMonthyData();
      } else if (this.selectedDateType == 3) {
        this.setYearlyData();
      }
    },
  },
};
</script>
